import {useNavigate} from "react-router-dom";
import React, {useEffect, useState} from "react";
import {divarLinkGenerator, safeRedirect} from "../../tools/helpers";
import Api from "../../tools/service";
import {Reoverlay} from "reoverlay";
import ErrorModal from "../../components/modals/ErrorModal";
import handleGenerateUuid from "../../tools/api/global/generateUuid";
import {AuthenticationDefaultSteps} from "../../tools/defaults/authentication/UserAuthentication";
import DivarInternalCarContext from "../../tools/contexts/DivarInternalCarContext";
import InitConfirm from "../../components/divarInternalCar/InitConfirm";
import LoadingScreen from "../../components/LoadingScreen";
import Final from "../../components/divarInternalCar/Final";
import {MdOutlineCheckCircle} from "react-icons/md";
import {VscError} from "react-icons/vsc";
import REQUEST_URLS from "../../tools/defaults/requestUrl";
import {FaCheckCircle} from "react-icons/fa";
import {BsHourglassSplit} from "react-icons/bs";
import useDivarAuth from "../../hooks/useDivarAuth";
const Steps = {
    INIT_CONFIRM: "InitConfirm",
    SHAHKAR: "Shahkar",
    CAR_MODEL_INQUIRY: "CarModelInquiry",
    CAR_CARD_INQUIRY: "CarCardInquiry",
    FINAL: "final"
}

const DivarInternalCar = () => {
    const navigate = useNavigate();
    const {serviceType,token,returnUrl,ticketUuid,postToken}=useDivarAuth();
    const [pid, setPid] = useState(null);
    const [isLoading, setIsLoading] = useState({
        showLoading: false,
        text: 'لطفا منتظر بمانید'
    });
    const [process, setProcess] = useState(null);
    const [components, setComponents] = useState(null);
    const [reported,setReported]=useState(false)
    const [finalData,setFinalData]=useState(null);

    const handleRedirectToDivar = ({price = 0, status}) => {
        const link = divarLinkGenerator({
            returnUrl,
            price,
            status,

        },true);
        safeRedirect(link,()=>{
            Reoverlay.showModal(ErrorModal,{
                title:'خطا',
                message:'لینک معتبر نمی باشد.',
                showCancelButton: true,
                cancelButtonText:'بستن',
                onCancel:()=>{
                    Reoverlay.hideModal();
                    navigate('/404')

                }
            })
        })
    }
    const handleCarCardInquiry = (newPid) => {
        setIsLoading({
            showLoading: true,
            text: ' در حال استعلام کارت خودرو'
        })
        handleGenerateUuid('CarCardInquiry', token).then((uuid) => {
            Api.post(REQUEST_URLS.DIVAR_INTERNAL_CAR.CAR_CARD_INQUIRY, {
                pid: newPid,
                uuid: uuid,

            }, {
                headers: {
                    "Authorization": `Bearer ${token}`
                },
            }).then((response) => {
                const {data, hasError, status, message} = response;

                if (!hasError) {
                    handleGetProcess(newPid)

                } else {
                    setIsLoading({
                        showLoading: false,
                        text: ' در حال استعلام کارت خودرو'
                    })
                    handleError({
                        message, status, data, callback: () => {
                            Reoverlay.showModal(ErrorModal, {
                                title: 'خطا',
                                message: message,
                                showCancelButton: true,
                                cancelButtonText: data?.can_reset ? "ویرایش اطلاعات" : 'تلاش مجدد',
                                onCancel: () => {
                                    if (data?.can_reset) {
                                        handleReset(newPid)
                                    } else {
                                        handleCarCardInquiry(newPid)
                                    }
                                }
                            })
                        }
                    })

                }

            }).catch(() => {

            }).finally(() => {

            })
        }).catch(() => {

        })
    }
    const handleProcess = (newProcess) => {
        setProcess(newProcess)
    }
    const handleLoading = (newLoading) => {
        setIsLoading(newLoading)
    }
    const handleUpdateStep = (newStep, passedStep) => {
        if (passedStep) {
            let passedSteps = [...process.passed_steps, passedStep];

            const newState = {
                ...process,
                current_step: newStep,
                passed_steps: passedSteps,
            }

            setProcess(newState)
        } else {
            const newState = {
                ...process,
                current_step: newStep
            }

            setProcess(newState)
        }
    };
    const handleCreateProcess = () => {
        setIsLoading({
            showLoading: true,
            text: 'در حال ساخت فرایند'
        })
        Api.post(REQUEST_URLS.DIVAR_INTERNAL_CAR.CREATE_PROCESS, {
            "post_token": ticketUuid+"|"+postToken
        }, {
            headers: {
                "Authorization": `Bearer ${token}`
            }
        }).then(response => {
            const {data, status, message, hasError} = response;

            if (hasError) {
                setIsLoading({
                    showLoading: false,
                    text: 'لطفا منتظر بمانید'
                })
                handleError({
                    data, status, message, callback: () => {
                        Reoverlay.showModal(ErrorModal, {
                            title: 'خطا',
                            message: message || 'خطای سرویس',
                            showConfirmButton: false,
                            showCancelButton: true,
                            cancelButtonText: status===845 ? 'بازگشت به دیوار':'تلاش مجدد',
                            cancelButtonTheme: status===845 ?"light":'red',
                            onCancel: () => {
                                if(status===845){
                                        handleRedirectToDivar({status:'fail',price:0})
                                }else {
                                    handleCreateProcess();
                                }

                            }
                        })
                    }
                })
            } else {
                setIsLoading({
                    showLoading: false,
                    text: 'در حال دریافت اطلاعات'
                })
                setPid(data.pid);
                handleGetProcess(data.pid)
            }
        }).catch(e => {
            console.log(e)
        }).finally(() => {

        })
    }
    const handleInquiryProcess = () => {
        setIsLoading({
            showLoading: true,
            text: 'در حال دریافت اطلاعات'
        })
        Api.get(REQUEST_URLS.DIVAR_INTERNAL_CAR.INQUIRY_PROCESS, {
            params:{
                post_token:ticketUuid,
                service_type:serviceType
            },
            headers: {
                "Authorization": `Bearer ${token}`
            }
        }).then(response => {
            const {status, data, message, hasError} = response;
            if (hasError) {
                setIsLoading({
                    showLoading: false,
                    text: 'در حال دریافت اطلاعات'
                })

                handleError({
                    status,
                    message,
                    data,

                    callback: () => {
                        Reoverlay.showModal(ErrorModal, {
                            title: 'خطا',
                            message: message || 'خطای سرویس',
                            showConfirmButton: false,
                            showCancelButton: true,
                            cancelButtonText: 'تلاش مجدد',
                            cancelButtonTheme: 'red',
                            onCancel: () => {
                                handleInquiryProcess();
                            }
                        })
                    }
                })
            } else {
                if (data?.process && data?.process?.pid) {
                    setPid(data.process.pid);
                    handleGetProcess(data.process.pid,true)

                } else {
                    handleCreateProcess();
                }
            }
        }).catch((e) => {

        }).finally(() => {

        })
    }
    const handleShahkar = (newPid) => {
        setIsLoading({
            showLoading: true,
            text: 'در حال تطابق کد ملی و شماره موبایل'
        })
        handleGenerateUuid('Shahkar', token).then(data => {
            if (data) {
                setIsLoading({
                    showLoading: true,
                    text: 'در حال تطابق کد ملی و شماره موبایل'
                })
                Api.post(REQUEST_URLS.DIVAR_INTERNAL_CAR.SHAHKAR, {
                    pid: newPid,
                    uuid: data,
                }).then((response) => {
                    const {data, hasError, status, message} = response;
                    if (!hasError) {
                        handleGetProcess(newPid)

                    } else {
                        setIsLoading({
                            showLoading: false,
                            text: 'در حال دریافت اطلاعات'
                        })

                        handleError({
                            message,
                            status,
                            data,
                            onCancel: () => {
                                handleShahkar(newPid);
                                Reoverlay.hideModal();
                            },
                            callback: () => {
                                Reoverlay.showModal(ErrorModal, {
                                    title: 'خطا',

                                    message: message || 'خطای دسترسی',
                                    showConfirmButton: data?.can_reset,
                                    confirmButtonText: 'ویرایش اطلاعات',
                                    confirmButtonTheme: "red",
                                    showCancelButton: status !== 360,
                                    cancelButtonText: 'تلاش مجدد',
                                    cancelButtonTheme: 'red',
                                    pid: newPid,
                                    onConfirm: () => {
                                        if (data.can_reset) {
                                            handleReset(newPid);
                                        }
                                        Reoverlay.hideModal();
                                    },
                                    onCancel: () => {
                                        handleShahkar(newPid);
                                        Reoverlay.hideModal();

                                    }
                                })
                            }
                        })


                    }

                }).catch(() => {
                    setIsLoading({
                        showLoading: false,
                        text: 'در حال دریافت اطلاعات'
                    })
                }).finally(() => {


                })
            } else {

            }


        }).catch(error => {
            console.log(error);
            setIsLoading({
                showLoading: false,
                text: 'در حال دریافت اطلاعات'
            })
        });

    }
    const handleGetProcess = (newPid,isInquiry) => {
        setIsLoading({
            showLoading: true,
            text: 'در حال دریافت اطلاعات'
        })

        Api.get(REQUEST_URLS.DIVAR_INTERNAL_CAR.FETCH_PROCESS, {
            params:{
                pid:newPid,
            },
            headers: {
                "Authorization": `Bearer ${token}`
            }
        }).then(response => {
            const {data, status, message, hasError} = response;
            if (hasError) {

                handleError({
                    status,
                    message,
                    data,
                    isInquiry,
                    callback: () => {
                        Reoverlay.showModal(ErrorModal, {
                            title: 'خطا',
                            message: message || 'خطای دسترسی',
                            showConfirmButton: false,
                            showCancelButton: true,
                            cancelButtonText: 'تلاش مجدد',
                            cancelButtonTheme: 'red',
                            onConfirm: () => {
                                Reoverlay.hideModal();
                            },
                            onCancel: () => {
                                handleGetProcess(newPid);
                            }
                        })
                    }
                })
            } else {
                setComponents(data.components)
                setProcess(data.process);
                if (data.components.current_component.name === Steps.SHAHKAR) {
                    handleShahkar(newPid);
                } else if (data.components.current_component.name === Steps.CAR_CARD_INQUIRY) {
                    handleCarCardInquiry(newPid);
                } else if (data.components.current_component.name === Steps.CAR_MODEL_INQUIRY) {
                    handleCarModelInquiry(newPid)
                }else if(data.components.current_component.name === Steps.FINAL){


                    setFinalData({
                        title:'موفق',
                        icon:<MdOutlineCheckCircle className="text-green-400  mb-3  text-6xl"/>,
                        message:'فرایند با موفقیت انجام شد',
                        status:'success',
                        onClick:()=>handleRedirectToDivar({status:'success'})
                    })
                    setIsLoading({
                        showLoading: false,
                        text: 'در حال دریافت اطلاعات'
                    })
                } else {
                    setIsLoading({
                        showLoading: false,
                        text: 'در حال دریافت اطلاعات'
                    })
                }

            }
        }).catch(e => {

        }).finally(() => {

        })
    }
    const handleError = ({onConfirm,isInquiry, onCancel, message, title, pid, data, status, options, callback}) => {
        if(status===-20){
            Reoverlay.showModal(ErrorModal,{
                title:'خطا',
                message:message,
                showCancelButton:false,
                showConfirmButton:false,
            })
        }else if (status === -10) {

            setReported(true)
            setIsLoading({
                showLoading: false,
                text: ''
            });
            setFinalData({
                title:'ناموفق',
                icon:<VscError className="text-red-400 mb-2   text-4xl"/>,
                message:message,
                status:'error',
                onClick:()=>handleRedirectToDivar({status:'fail'})
            })

        }else if(status===-11){

            setReported(true)
            setIsLoading({
                showLoading: false,
                text: ''
            });
            setFinalData({
                title:'در حال بررسی',
                icon:<BsHourglassSplit className={'text-yellow-500 mb-3   text-4xl'}  />,
                message:message,
                status:'warning',
                onClick:()=>handleRedirectToDivar({status:'fail'})
            })
        }else if(status===-12){

            setReported(true)
            setIsLoading({
                showLoading: false,
                text: ''
            });
            setFinalData({
                title:'موفق',
                icon:<FaCheckCircle className={'text-green-500 mb-3   text-4xl'}/>,
                message:message,
                status:'success',
                onClick:()=>handleRedirectToDivar({status:'success'})
            })
        } else if (status === 500) {
            Reoverlay.showModal(ErrorModal, {
                title: 'خطا',
                message: message || 'خطای سرویس',
                onConfirm: () => {
                    Reoverlay.hideModal();
                },
                showConfirmButton: false,
                showCancelButton: true,
                cancelButtonText: 'تلاش مجدد',
                cancelButtonTheme: 'red',

                onCancel: () => {
                    if (onCancel) {
                        onCancel()
                    }

                }
            })

        } else if (status === 403 || status === 401) {
            Reoverlay.showModal(ErrorModal, {
                title: 'خطا',
                message: message || 'خطای دسترسی',
                onConfirm: () => {
                    Reoverlay.hideModal();
                },
                showConfirmButton: false,
                showCancelButton: true,
                cancelButtonText: 'دریافت دسترسی ',
                cancelButtonTheme: 'red',

                onCancel: () => {
                    navigate('/auth/gate/v11dW62X4kaZ2Hn4/' + serviceType + '?post_token=' + postToken)

                }
            })
        } else if (status === 801 || status === 802 || status === 803 || status === 805) {
            Reoverlay.showModal(ErrorModal, {
                title: 'خطا',
                message: message || 'خطای دسترسی',
                onConfirm: () => {
                    Reoverlay.hideModal();
                },
                showConfirmButton: false,
                showCancelButton: true,
                cancelButtonText: 'ساخت پروسه جدید',
                cancelButtonTheme: 'red',
                onCancel: () => {
                    handleCreateProcess();
                }
            })
        } else {
            callback()
        }
    }
    const handleComponents = (newComponents) => {
        setComponents(newComponents)
    }
    const handleCarModelInquiry = (newPid) => {
        setIsLoading({
            showLoading: true,
            text: 'در حال بررسی مدل خودرو'
        })
        handleGenerateUuid('CarModelInquiry', token).then((uuid) => {
            Api.post(REQUEST_URLS.DIVAR_INTERNAL_CAR.CAR_MODEL_INQUIRY, {
                pid: newPid,
                uuid: uuid,
            }, {
                headers: {
                    "Authorization": `Bearer ${token}`
                },
            }).then((response) => {
                const {data, hasError, status, message} = response;

                if (!hasError) {
                    handleGetProcess(newPid)

                } else {
                    setIsLoading({
                        showLoading: false,
                        text: 'در حال دریافت اطلاعات'
                    })
                    handleError({
                        message, status, data, callback: () => {
                            Reoverlay.showModal(ErrorModal, {
                                title: 'خطا',
                                message: message,
                                showCancelButton: true,
                                cancelButtonText: data?.can_reset ? "ویرایش اطلاعات" : 'تلاش مجدد',
                                onCancel: () => {
                                    if (data?.can_reset) {
                                        handleReset(newPid)
                                    } else {
                                        handleCarModelInquiry(newPid)
                                    }
                                }
                            })
                        }
                    })
                }

            }).catch(() => {

            }).finally(() => {


            })
        }).catch(() => {

        })
    }
    const handleReset = (newPid) => {
        setIsLoading({
            showLoading: true,
            text: 'لطفا منتظر بمانید'
        })
        Api.post(REQUEST_URLS.DIVAR_INTERNAL_CAR.RESET_PROCESS, {
            pid: newPid,
        }, {
            headers: {
                "Authorization": `Bearer ${token}`
            }
        }).then(response => {
            const {hasError, data, message, status} = response;
            if (hasError) {
                handleError({
                    status,
                    message,
                    data,
                    callback: () => {
                        Reoverlay.showModal(ErrorModal, {
                            title: 'خطا',
                            message: message || 'خطای دسترسی',
                            showConfirmButton: false,
                            showCancelButton: true,
                            cancelButtonText: 'تلاش مجدد',
                            cancelButtonTheme: 'red',
                            onConfirm: () => {
                                Reoverlay.hideModal();
                            },
                            onCancel: () => {
                                handleReset(newPid);
                                Reoverlay.hideModal();
                            }
                        })
                    }
                })
            } else {
                handleGetProcess(newPid)
            }
        }).finally(() => {

        })
    }
    useEffect(() => {
        handleInquiryProcess()
    }, []);
    if (isLoading.showLoading) {
        return <LoadingScreen text={isLoading.text}/>
    }
    if(reported){
        return <Final data={finalData}/>
    }
    return <>
        <DivarInternalCarContext.Provider value={{
            postToken,
            isLoading,
            pid,
            token,
            process,
            components,
            handleLoading,
            handleUpdateStep,
            handleProcess,
            handleError,
            handleComponents,
            handleGetProcess,
            handleCreateProcess,
            handleReset,
            handleRedirectToDivar,

        }}>
            {process && components?.current_component?.name === AuthenticationDefaultSteps.INIT_CONFIRM && <InitConfirm/>}
            {process && components?.current_component?.name === AuthenticationDefaultSteps.FINAL && <Final  />}
        </DivarInternalCarContext.Provider>
    </>
}
export default DivarInternalCar